module.exports = __webpack_public_path__ + "img/growcify-ad-film.d333b52f.png";